import { useQuery } from '@tanstack/react-query';
import { countryKey } from '../queryKeys';
import api from '../api';
import { getCloudflareCountryCode } from '../lib/get-cloudflare-country-code';
import storage from '../services/storage';

export function useCountryCode() {
  const {
    data: countryCode,
    isLoading: isLoadingCountryCode,
    isError: isApiError,
  } = useQuery({
    queryKey: countryKey,
    queryFn: () => api.getCountryCode(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false,
    retryDelay: 1000,
    staleTime: 1000 * 60 * 60 * 24,
  });

  const { data: cloudflareCountryCode, isError: isCloudflareError } = useQuery({
    queryKey: countryKey,
    queryFn: () => getCloudflareCountryCode(),
    retry: false,
    enabled: !countryCode && !isLoadingCountryCode,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retryDelay: 1000,
    staleTime: 1000 * 60 * 60 * 24,
  });

  if (isApiError && isCloudflareError) {
    // Handle the error case, e.g., show an error message or use a default value
    return null;
  }

  if (countryCode || cloudflareCountryCode) {
    storage.session.setItem('CheckoutPage.country', countryCode || cloudflareCountryCode);
  }

  return countryCode || cloudflareCountryCode;
}
